import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';


export default {
  name: "PromoCodesView",
  components: {
    Navbar,
    Sidebar,
  },
  data() {
    return ({
      token_exists: null,
      user_details: { user_role: "" },
      is_loading: false,
      is_saving: false,
      promo_codes: [],
      discount_types: [],
      promo_query: "",
      promo_status_filter: "all",
      promo_form: {
        id: null,
        promo_code_name: "",
        promo_code_type_id: "",
        discount_amount: "",
        valid_start_date: null,
        valid_end_date: null,
        usage_limit: 0,
        minimum_order_amount: 0,
        is_active: true,
      },
      promo_errors: {},
    });
  },
  computed: {
    is_admin() {
      return this.token_exists && this.user_details?.user_role === "admin";
    },
    filtered_promo_codes() {
      const query = String(this.promo_query || "").trim().toLowerCase();
      return (this.promo_codes || []).filter((promo) => {
        const name = String(this.get_promo_name(promo)).toLowerCase();
        const type = String(this.get_promo_type_name(promo)).toLowerCase();
        const matches_query = !query || name.includes(query) || type.includes(query);
        const matches_status =
          this.promo_status_filter === "all" ||
          (this.promo_status_filter === "active" && this.is_promo_active(promo)) ||
          (this.promo_status_filter === "inactive" && !this.is_promo_active(promo));
        return matches_query && matches_status;
      });
    },
    active_promo_count() {
      return (this.promo_codes || []).filter((promo) => this.is_promo_active(promo)).length;
    },
  },
  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details() || { user_role: "" };

    if (!this.is_admin) return;
    this.fetch_discount_types();
    this.fetch_promo_codes();
  },
  methods: {
    get_token() {
      return get_token();
    },
    open_create_modal() {
      this.reset_form();
      $("#system_promo_code_modal").modal("show");
    },
    open_edit_modal(promo) {
      this.reset_form();
      this.promo_form = {
        id: promo?.id || null,
        promo_code_name: this.get_promo_name(promo),
        promo_code_type_id: this.get_promo_type_id(promo),
        discount_amount: this.get_promo_discount(promo),
        valid_start_date: this.get_date_time_local_string(this.get_promo_start_date(promo)),
        valid_end_date: this.get_date_time_local_string(this.get_promo_end_date(promo)),
        usage_limit: this.get_promo_usage_limit(promo),
        minimum_order_amount: this.get_promo_minimum_order_amount(promo),
        is_active: this.is_promo_active(promo),
      };
      $("#system_promo_code_modal").modal("show");
    },
    reset_form() {
      this.promo_errors = {};
      this.promo_form = {
        id: null,
        promo_code_name: "",
        promo_code_type_id: this.discount_types?.[0]?.id || "",
        discount_amount: "",
        valid_start_date: null,
        valid_end_date: null,
        usage_limit: 0,
        minimum_order_amount: 0,
        is_active: true,
      };
    },
    get_selected_discount_type() {
      return this.discount_types.find(
        (type) => String(type.id) === String(this.promo_form.promo_code_type_id),
      );
    },
    validate_discount_type() {
      if (this.promo_form.promo_code_type_id) return true;

      this.promo_errors.promo_code_type_id = "Discount type is required.";
      return false;
    },
    validate_discount_amount() {
      const discount = Number(this.promo_form.discount_amount);
      const selected_type = this.get_selected_discount_type();
      const selected_type_name = String(selected_type?.name || selected_type?.label || "").toLowerCase();

      if (this.promo_form.discount_amount === "" || Number.isNaN(discount) || discount <= 0) {
        this.promo_errors.discount_amount = "Discount amount must be greater than 0.";
        return false;
      }

      if (selected_type_name === "percentage" && discount > 100) {
        this.promo_errors.discount_amount = "Percentage cannot exceed 100%.";
        return false;
      }

      return true;
    },
    validate_date_range() {
      const start_timestamp = new Date(this.promo_form.valid_start_date).getTime();
      const end_timestamp = new Date(this.promo_form.valid_end_date).getTime();

      if (this.promo_form.valid_start_date && this.promo_form.valid_end_date && end_timestamp <= start_timestamp) {
        this.promo_errors.valid_end_date = "End date must be greater than the start date.";
        return false;
      }

      return true;
    },
    validate_positive_or_zero(field, message) {
      const allowed_fields = ["minimum_order_amount", "usage_limit"];
      if (!allowed_fields.includes(field)) return true;

      const value = Number(Reflect.get(this.promo_form, field) || 0);

      if (!Number.isNaN(value) && value >= 0) return true;

      Reflect.set(this.promo_errors, field, message);
      return false;
    },
    validate_form() {
      this.promo_errors = {};
      const validations = [
        this.validate_discount_type(),
        this.validate_discount_amount(),
        this.validate_date_range(),
        this.validate_positive_or_zero("minimum_order_amount", "Minimum order amount cannot be less than 0."),
        this.validate_positive_or_zero("usage_limit", "Usage limit cannot be less than 0."),
      ];

      return validations.every(Boolean);
    },
    build_payload() {
      const promo_code_name = String(this.promo_form.promo_code_name || "").trim();

      return ({
        ...(promo_code_name ? { promo_code_name } : {}),
        promo_code_type_id: this.promo_form.promo_code_type_id,
        discount_amount: this.promo_form.discount_amount,
        valid_start_date: this.promo_form.valid_start_date || null,
        valid_end_date: this.promo_form.valid_end_date || null,
        usage_limit: String(this.promo_form.usage_limit || 0),
        minimum_order_amount: this.promo_form.minimum_order_amount || 0,
        has_usage_limit: Number(this.promo_form.usage_limit || 0) > 0,
        is_active: this.promo_form.is_active,
      });
    },
    fetch_discount_types() {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_promo_code_types/`,
        method: "GET",
        headers: {
          Authorization: `Token ${this.get_token()}`,
          "Content-Type": "application/json",
        },
        success: (response) => {
          this.discount_types = (response.data || []).map((type) => ({
            id: type.id,
            label: type.name.charAt(0).toUpperCase() + type.name.slice(1),
            name: type.name,
          }));
          this.promo_form.promo_code_type_id = this.discount_types?.[0]?.id || "";
        },
      });
    },
    fetch_promo_codes() {
      this.is_loading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_company_promo_codes/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.get_token()}`,
          "Content-Type": "application/json",
        },
        success: (response) => {
          this.promo_codes = response.data || [];
        },
        error: (response) => {
          this.show_error(response, "An error occurred while loading promo codes.");
        },
        complete: () => {
          this.is_loading = false;
        },
      });
    },

    submit_promo_code() {
      if (!this.validate_form()) return;

      const is_editing = Boolean(this.promo_form.id);
      this.is_saving = true;
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/${is_editing ? "update_promo_code" : "create_global_promo_code"}/`,
        data: JSON.stringify({
          ...(is_editing ? { promo_code_id: this.promo_form.id } : {}),
          ...this.build_payload(),
        }),
        processData: true,
        contentType: "application/json",
        headers: {
          Authorization: `Token ${this.get_token()}`,
        },
        success: (response) => {
          if (response.status !== "success") return;

          const saved_promo = response.data || {
            id: this.promo_form.id,
            ...this.build_payload(),
            promo_code_type: this.discount_types.find(
              (type) => String(type.id) === String(this.promo_form.promo_code_type_id),
            ),
          };

          if (is_editing) {
            const promo_index = this.promo_codes.findIndex(
              (promo) => String(promo.id) === String(this.promo_form.id),
            );
            if (promo_index !== -1) this.promo_codes.splice(promo_index, 1, saved_promo);
          } else {
            this.promo_codes.unshift(saved_promo);
          }

          $("#system_promo_code_modal").modal("hide");
          this.reset_form();
          this.show_success(is_editing ? "Promo Code Updated" : "Promo Code Created", response.message);
        },
        error: (response) => {
          this.show_error(response, "An error occurred while saving promo code.");
        },
        complete: () => {
          this.is_saving = false;
        },
      });
    },
    toggle_promo_status(promo) {
      const previous_state = this.is_promo_active(promo);
      const payload = {
        promo_code_id: promo.id,
        is_active: !previous_state,
      };

      promo.is_active = !previous_state;
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/toggle_promo_code_status/`,
        data: JSON.stringify(payload),
        processData: true,
        contentType: "application/json",
        headers: {
          Authorization: `Token ${this.get_token()}`,
        },
        error: (response) => {
          promo.is_active = previous_state;
          this.show_error(response, "An error occurred while updating promo code status.");
        },
      });
    },
    delete_promo_code(promo) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this promo code?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
      }).then((result) => {
        if (!result.isConfirmed) return;

        $.ajax({
          type: "POST",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/delete_promo_code/`,
          data: JSON.stringify({ promo_code_id: promo.id }),
          processData: true,
          contentType: "application/json",
          headers: {
            Authorization: `Token ${this.get_token()}`,
          },
          success: (response) => {
            if (response.status !== "success") return;
            this.promo_codes = this.promo_codes.filter(
              (item) => String(item.id) !== String(promo.id),
            );
            this.show_success("Promo Code Deleted", response.message);
          },
          error: (response) => {
            this.show_error(response, "An error occurred while deleting promo code.");
          },
        });
      });
    },
    get_promo_name(promo) {
      return promo?.code || promo?.promo_code_name || promo?.promo_code?.promo_code_name || "-";
    },

    get_promo_type_id(promo) {
      return promo?.promo_code?.promo_code_type?.id || promo?.promo_code_type?.id || promo?.promo_code_type_id || "";
    },
    get_promo_type_name(promo) {
      return promo?.promo_code?.promo_code_type?.name || promo?.promo_code_type?.name || promo?.promo_code_type?.label || "-";
    },
    get_promo_discount(promo) {
      return promo?.discount_amount ?? promo?.promo_code?.discount_amount ?? "";
    },
    get_promo_start_date(promo) {
      return promo?.valid_start_date || promo?.promo_code?.valid_start_date || null;
    },
    get_promo_end_date(promo) {
      return promo?.valid_end_date || promo?.promo_code?.valid_end_date || null;
    },
    get_promo_usage_limit(promo) {
      return promo?.usage_limit ?? promo?.promo_code?.usage_limit ?? 0;
    },
    get_promo_minimum_order_amount(promo) {
      return promo?.minimum_order_amount ?? promo?.promo_code?.minimum_order_amount ?? 0;
    },
    get_promo_usage_count(promo) {
      return promo?.usage_count ?? promo?.promo_code?.usage_count ?? 0;
    },
    is_percentage_promo(promo) {
      return String(this.get_promo_type_name(promo)).toLowerCase() === "percentage";
    },
    is_promo_active(promo) {
      return promo?.is_active !== false;
    },
    format_discount(promo) {
      const amount = Number(this.get_promo_discount(promo) || 0);
      if (this.is_percentage_promo(promo)) return `${amount}%`;
      return `R${amount.toLocaleString("en-ZA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    },
    get_date_time_local_string(date_string) {
      if (!date_string) return null;
      const date = new Date(date_string);
      if (Number.isNaN(date.getTime())) return null;

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    format_date(date_string) {
      if (!date_string) return "-";
      const date = new Date(date_string);
      if (Number.isNaN(date.getTime())) return "-";
      return date.toLocaleDateString();
    },
    format_amount(amount) {
      return Number(amount || 0).toLocaleString("en-ZA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    show_success(title, text) {
      Swal.fire({
        icon: "success",
        title,
        text,
        showConfirmButton: false,
        timer: 2000,
      });
    },
    show_error(response, fallback) {
      const response_data = response?.responseJSON || {};
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response_data.message || fallback,
        showConfirmButton: false,
        timer: 3000,
      });
    },

    open_catalogue_promo_code_manager() {
      this.open_create_modal();
    },
  },
};
